var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchandFilterResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H13.3333V6.54545H20V24H0V0ZM14.4444 1.09091V5.45455H18.8889L14.4444 1.09091ZM14.6566 13.8283C14.6566 15.0162 14.3012 16.1211 13.6909 17.0424L16.6586 20.0101C17.1138 20.4653 17.1138 21.2034 16.6586 21.6586C16.2034 22.1138 15.4653 22.1138 15.0101 21.6586L12.0424 18.6909C11.1211 19.3012 10.0162 19.6566 8.82828 19.6566C5.60941 19.6566 3 17.0471 3 13.8283C3 10.6094 5.60941 8 8.82828 8C12.0471 8 14.6566 10.6094 14.6566 13.8283ZM8.82828 17.9081C11.0815 17.9081 12.9081 16.0815 12.9081 13.8283C12.9081 11.5751 11.0815 9.74848 8.82828 9.74848C6.57507 9.74848 4.74848 11.5751 4.74848 13.8283C4.74848 16.0815 6.57507 17.9081 8.82828 17.9081Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchandFilterResult);
export default __webpack_public_path__ + "static/media/SearchandFilterResult.f1c9535c9e3619ada1feb55287b3304b.svg";
export { ForwardRef as ReactComponent };